export default [
  {
    path: '/requests',
    name: 'Requests_Sent',
    component: () => import('@/views/requests/sent.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.index'
    }
  },
  {
    path: '/requests/inbox',
    name: 'Requests_Inbox',
    component: () => import('@/views/requests/inbox.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.inbox'
    }
  },
  {
    path: '/requests/archive',
    name: 'Requests_Archive',
    component: () => import('@/views/requests/archive.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.archive'
    }
  },

  {
    path: '/requests/create',
    name: 'Requests_Create',
    component: () => import('@/views/requests/create.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.store'
    }
  },
  {
    path: '/requests/:id',
    name: 'Requests_Detail',
    component: () => import('@/views/requests/show.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.show',
      navActiveLink: 'Requests_Sent',
    }
  },
  {
    path: '/requests/:id/edit',
    name: 'Requests_Edit',
    component: () => import('@/views/requests/edit.vue'),
    meta: {
      authRequired: true,
      permission: 'requests.update',
      navActiveLink: 'Requests_Sent',
    }
  },
]
